/** 문서 컴포넌트(CddDocVarField 등)가 패널의 현재 활성 문서 상태에 접근하는 provide/inject 컨텍스트. */
import type { InjectionKey, Ref } from 'vue';
import type { CddFieldType } from './cddFields';
import type { ComboOpt } from './cddOptions';

export interface CddDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => CddFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;       // 변수 클릭 → 패널이 챗봇/입력 라우팅
  setFieldValue: (key: string, val: string) => void; // 드래그앤드롭 직접 채우기
  openAddress: (key: string) => void;    // 주소 필드 📍 → 말레이시아 주소 입력 모달
  checkboxValue: Ref<string>;            // 현재 문서의 체크박스 그룹 선택값 (bt_*/at_*)
  setCheckbox: (val: string) => void;
  /** combo 옵션 — share_type 은 Ordinary/Preference/Others 고정 3종, 그 외는 정적 JSON. */
  comboOptionsOf: (key: string) => ComboOpt[];
  /** Legal Person Shareholder/BO 테이블 동적 행 수 (데이터만큼 늘어남). */
  shareholderRowCount: Ref<number>;
  boRowCount: Ref<number>;
  /** Shareholder / BO through other means — 행 추가/삭제 (1-based index). */
  addShareholderRow: () => void;
  removeShareholderRow: (index: number) => void;
  addBoRow: () => void;
  removeBoRow: (index: number) => void;
  /** pick-place: 챗봇 상세카드의 copy 클릭으로 "보관"된 값. 있으면 필드 클릭 시 그 필드에 삽입. */
  pendingPickValue: Ref<string>;
  /** pendingPickValue 를 key 필드에 삽입. 삽입되면 true (호출측이 활성화/편집 대신 처리). */
  placePick: (key: string) => boolean;
}

export const CDD_DOC_CTX: InjectionKey<CddDocContext> = Symbol('cddDocCtx');
